import React from 'react';
export function TermsPage() {
  return <main className="w-full" data-id="element-964">
      {/* Hero Section */}
      <section className="w-full bg-gradient-to-br from-[#07493a] to-[#1a6b55] py-20 px-4" data-id="element-965">
        <div className="max-w-7xl mx-auto text-center" data-id="element-966">
          <h1 className="text-4xl md:text-6xl font-serif font-bold text-white mb-6" data-id="element-967">
            Terms & Conditions
          </h1>
          <p className="text-xl text-gray-300 max-w-3xl mx-auto" data-id="element-968">
            Last updated: February 24, 2026
          </p>
        </div>
      </section>

      {/* Content Section */}
      <section className="w-full bg-cream py-20 px-4" data-id="element-969">
        <div className="max-w-4xl mx-auto bg-white rounded-2xl shadow-lg p-8 md:p-12" data-id="element-970">
          <div className="prose prose-lg max-w-none" data-id="element-971">
            <h2 className="text-2xl font-serif font-bold text-gray-900 mb-4" data-id="element-972">
              1. Acceptance of Terms
            </h2>
            <p className="text-gray-700 mb-6 leading-relaxed" data-id="element-973">
              By accessing and using the EquityRich.ca website, you accept and
              agree to be bound by the terms and provision of this agreement. If
              you do not agree to these terms, please do not use this website.
            </p>

            <h2 className="text-2xl font-serif font-bold text-gray-900 mb-4" data-id="element-974">
              2. Use of Website
            </h2>
            <p className="text-gray-700 mb-6 leading-relaxed" data-id="element-975">
              This website is provided for informational purposes only. The
              content on this site, including but not limited to text, graphics,
              images, and other material, is for general information purposes
              only and should not be construed as financial, legal, or
              professional advice.
            </p>

            <h2 className="text-2xl font-serif font-bold text-gray-900 mb-4" data-id="element-976">
              3. Mortgage Services
            </h2>
            <p className="text-gray-700 mb-6 leading-relaxed" data-id="element-977">
              EquityRich.ca operates as a referral institution. Mortgage Agents
              and Brokers represent Everything Mortgages (FSRA #12755). All
              mortgage products and services are subject to approval and
              qualification requirements. Terms, conditions, and rates are
              subject to change without notice.
            </p>

            <h2 className="text-2xl font-serif font-bold text-gray-900 mb-4" data-id="element-978">
              4. Application Process
            </h2>
            <p className="text-gray-700 mb-6 leading-relaxed" data-id="element-979">
              By submitting an application through our website, you authorize
              EquityRich.ca and its partners to contact you regarding your
              inquiry. You understand that submission of an application does not
              guarantee approval or funding. All applications are subject to
              property assessment, equity verification, and other standard
              lending criteria.
            </p>

            <h2 className="text-2xl font-serif font-bold text-gray-900 mb-4" data-id="element-980">
              5. Privacy and Data Protection
            </h2>
            <p className="text-gray-700 mb-6 leading-relaxed" data-id="element-981">
              Your privacy is important to us. Please refer to our Privacy
              Policy for information about how we collect, use, and protect your
              personal information.
            </p>

            <h2 className="text-2xl font-serif font-bold text-gray-900 mb-4" data-id="element-982">
              6. Intellectual Property
            </h2>
            <p className="text-gray-700 mb-6 leading-relaxed" data-id="element-983">
              All content on this website, including text, graphics, logos,
              images, and software, is the property of EquityRich.ca or its
              content suppliers and is protected by Canadian and international
              copyright laws. Unauthorized use of any content may violate
              copyright, trademark, and other laws.
            </p>

            <h2 className="text-2xl font-serif font-bold text-gray-900 mb-4" data-id="element-984">
              7. Limitation of Liability
            </h2>
            <p className="text-gray-700 mb-6 leading-relaxed" data-id="element-985">
              EquityRich.ca and its affiliates shall not be liable for any
              direct, indirect, incidental, consequential, or punitive damages
              arising out of your access to or use of this website. This
              includes, but is not limited to, damages for loss of profits,
              data, or other intangible losses.
            </p>

            <h2 className="text-2xl font-serif font-bold text-gray-900 mb-4" data-id="element-986">
              8. Changes to Terms
            </h2>
            <p className="text-gray-700 mb-6 leading-relaxed" data-id="element-987">
              EquityRich.ca reserves the right to modify these terms and
              conditions at any time. Changes will be effective immediately upon
              posting to the website. Your continued use of the website
              following the posting of changes constitutes your acceptance of
              such changes.
            </p>

            <h2 className="text-2xl font-serif font-bold text-gray-900 mb-4" data-id="element-988">
              9. Governing Law
            </h2>
            <p className="text-gray-700 mb-6 leading-relaxed" data-id="element-989">
              These terms and conditions are governed by and construed in
              accordance with the laws of the Province of Ontario and the
              federal laws of Canada applicable therein. Any disputes arising
              from these terms shall be subject to the exclusive jurisdiction of
              the courts of Ontario.
            </p>

            <h2 className="text-2xl font-serif font-bold text-gray-900 mb-4" data-id="element-990">
              10. Contact Information
            </h2>
            <p className="text-gray-700 leading-relaxed" data-id="element-991">
              If you have any questions about these Terms & Conditions, please
              contact us at:
            </p>
            <p className="text-gray-700 mt-4" data-id="element-992">
              <strong data-id="element-993">EquityRich.ca</strong>
              <br data-id="element-994" />
              18 Wynford Dr, Suite 307
              <br data-id="element-995" />
              Toronto, ON, M3C 3S2
              <br data-id="element-996" />
              Email: info@equityrich.ca
              <br data-id="element-997" />
              Phone: +1-647-667-9957
            </p>
          </div>
        </div>
      </section>
    </main>;
}